import { fromJS } from 'immutable';

import { successAction, failureAction } from '@utils/actions';
import { INIT_STORE } from '@shared/actionTypes';
import orderFlowReducer from '@core/utils/orderFlowReducer';

import * as actions from './actionTypes';
import ModuleStateModel from './model';

const initialState = ModuleStateModel;

function menuSearchModuleReducer(state = initialState, action) {
  switch (action.type) {
    case INIT_STORE:
      return ModuleStateModel.mergeDeep(state);

    case actions.SEARCH_MENU_PRODUCTS:
      return state.set('isFetchingResults', true);

    case actions.FILTER_SECTION_ITEMS:
      return state.set('filter', action.payload);

    case successAction(actions.SEARCH_MENU_PRODUCTS): {
      const { search, query, fetchMore } = action.payload;

      if (!search) return initialState;

      const newState =
        state.get('query') === query && fetchMore
          ? state.updateIn(['search', 'data'], data =>
              data.concat(fromJS(search.data)),
            )
          : state.set('search', fromJS(search));

      return newState
        .setIn(['search', 'total'], search.total)
        .set('query', query)
        .set('isFetchingResults', false);
    }

    case failureAction(actions.SEARCH_MENU_PRODUCTS):
      return state.set('isFetchingResults', false);

    case actions.CLEAN_SEARCH:
      return initialState;

    default:
      return state;
  }
}

export default orderFlowReducer(menuSearchModuleReducer, initialState);
